import { API } from "./api";

// Racine de l'API sans le suffixe /api (ex: "https://noldgo.com").
const BASE = API.replace(/\/api$/, "");

/**
 * Résout une URL média retournée par le backend en URL absolue chargeable côté client.
 *
 * Gère les 3 cas rencontrés :
 *   1. `null` / `undefined` / chaîne vide       → renvoie `null`
 *   2. URL absolue (http/https, ex: Emergent   → renvoyée telle quelle
 *      Object Storage, CDN, S3)
 *   3. Chemin relatif (ex: "/api/restaurants   → préfixé par BASE (racine sans /api)
 *      /xyz/cover?v=123", "/api/menu/abc/photo")
 *
 * Utiliser ce helper au lieu de `${API}${path}` (double /api) ou `${BASE}${path}`
 * (casse quand path est absolu).
 */
export function mediaUrl(path) {
  if (!path) return null;
  const s = String(path);
  if (s.startsWith("http://") || s.startsWith("https://") || s.startsWith("data:") || s.startsWith("blob:")) {
    return s;
  }
  return `${BASE}${s}`;
}

export default mediaUrl;
